export const interactiveWebglDemoGql = `... on landingPageContent_interactiveWebglDemo_BlockType{
	typeHandle
	title
	demoEntry(limit:1) {
		slug
	}
}`;
